import React from "react";
import { Globe, ShieldCheck, FileCheck2, Smartphone } from "lucide-react";
import { IMAGES } from "@/lib/site";
import { Reveal } from "@/components/landing/Reveal";
import { ActivityChips } from "@/components/landing/HeroParts";

const CHIPS = [
  { icon: FileCheck2, label: "Online visa platforms" },
  { icon: ShieldCheck, label: "Travel insurance" },
  { icon: Smartphone, label: "Travel eSIM" },
  { icon: Globe, label: "English & other language markets" },
];

const HERO_PARAGRAPH =
  "Moruya Travel Solutions is the parent company behind a growing family of travel " +
  "platforms across three activities — online visa applications, travel insurance and " +
  "travel eSIMs. Registered in the United Arab Emirates with its office in Dubai, it " +
  "owns the brands, the technology and the partner agreements behind the group's online " +
  "travel services. Rather than one storefront, the group builds a separate website for " +
  "each audience and language, and travellers are served by our operating brands in " +
  "English and other languages — Turkish travellers heading to Dubai first, with further " +
  "markets following as the portfolio grows. This site is the group's corporate profile " +
  "for partners, suppliers, corporate contacts and press; travellers are served on the " +
  "portals listed below.";

const HeroCopy = () => (
  <div className="lg:col-span-7">
    <Reveal delay={0.05}>
      <h1 className="font-display text-3xl tracking-tight text-[#0b1d3a] sm:text-4xl lg:text-5xl">
        The group behind our online travel platforms.
      </h1>
    </Reveal>

    <Reveal delay={0.1}>
      <p
        data-testid="about-paragraph"
        className="mt-5 text-sm leading-relaxed text-slate-600 sm:text-base"
      >
        {HERO_PARAGRAPH}
      </p>
    </Reveal>

    <Reveal delay={0.2}>
      <ActivityChips items={CHIPS} />
    </Reveal>
  </div>
);

const HeroImage = () => (
  <div className="lg:col-span-5">
    <Reveal delay={0.12}>
      <div className="overflow-hidden rounded-[20px] border border-slate-200 bg-white shadow-[var(--shadow-lg)]">
        <img
          src={IMAGES.hero}
          alt="Dubai coastline and skyline"
          className="h-[200px] w-full object-cover sm:h-[260px] lg:h-[340px]"
          loading="eager"
        />
      </div>
    </Reveal>
  </div>
);

/** Home / about block: headline, combined corporate paragraph and one image. */
export const Hero = () => (
  <section
    id="about"
    data-testid="about-section"
    aria-label="Introduction"
    className="noise relative overflow-hidden scroll-mt-32 lg:scroll-mt-40 lg:flex lg:min-h-[calc(100vh-9.5rem)] lg:items-center"
  >
    <div className="bg-harbor-mist absolute inset-0 -z-10" aria-hidden="true" />

    <div className="mx-auto w-full max-w-6xl px-4 pb-10 pt-8 sm:px-6 sm:pb-12 sm:pt-10 lg:px-8 lg:py-12">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12">
        <HeroCopy />
        <HeroImage />
      </div>
    </div>
  </section>
);
